import React from 'react';
import { SvgProps } from '../../../models/components/svg';

const BankIcon: React.FC<SvgProps> = ({ className }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="80"
        height="80"
        viewBox="0 0 80 80"
        fill="none"
    >
        <rect width="80" height="80" rx="40" fill="#ECF3FF" />
        <circle cx="40" cy="40" r="40" fill="#ECF3FF" />
        <path
            d="M31.2974 39.9961H28.1177V52.7152H31.2974V39.9961Z"
            stroke="#55ADED"
            stroke-width="0.96"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M41.5062 39.9961H38.3264V52.7152H41.5062V39.9961Z"
            stroke="#55ADED"
            stroke-width="0.96"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M51.7149 39.9961H48.5352V52.7152H51.7149V39.9961Z"
            stroke="#55ADED"
            stroke-width="0.96"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M25.4399 52.7148L25.4399 55.8945L54.5599 55.8945L54.5599 52.7148L25.4399 52.7148Z"
            stroke="#192B4D"
            stroke-width="0.96"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M25.4399 34.3897V36.8164H54.5599V34.3897"
            stroke="#192B4D"
            stroke-width="0.96"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M25.4399 34.3051L39.9973 24.2637L54.5599 34.3051"
            stroke="#192B4D"
            stroke-width="0.96"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M33.8079 33.3005L39.9989 28.9492L46.1922 33.3005"
            stroke="#192B4D"
            stroke-width="0.96"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
);

export default BankIcon;
